LieuValidator.$inject = ['validator'];

export default function LieuValidator(validator) {
    const instance = new validator();
    return instance;
}
